import React from 'react';
import { useTranslation } from 'react-i18next';
import EditIcon from '@mui/icons-material/Edit';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import { IconButton, Link, Tooltip } from '@mui/material';

import EditTravelStudyFolderModal from 'components/pages/study/StudyDetails/TravelStudyFolder/EditTravelStudyFolderModal';

import ModalBoxes from '../../../../../common/feedback/ModalBoxes/ModalBoxes';
import { ROLE_SYSTEM_ADMINISTRATOR, ROLE_TRAVEL_COORDINATOR } from '../../../../../constants/userRoles';
import { userHasRole } from '../../../../../services/auth';
import { NSPS_STUDY } from '../../../../../services/i18n/namespaces';

import './TravelStudyFolder.scss';

export function TravelStudyFolder({ studyDetails, onStudyDetailsTravelFolderLinkUpdate, isStudyTypeCTMS }) {
  const { t } = useTranslation();
  const userIsSysAdmin = userHasRole(ROLE_SYSTEM_ADMINISTRATOR);
  const userIsTravelCoordinator = userHasRole(ROLE_TRAVEL_COORDINATOR);

  const openEditLinkModal = () => {
    ModalBoxes.open({
      component: (
        <EditTravelStudyFolderModal
          studyDetails={studyDetails}
          onStudyDetailsTravelFolderLinkUpdate={onStudyDetailsTravelFolderLinkUpdate}
        />
      ),
      size: 'w500'
    });
  };

  const renderEditIconButton = () => {
    if (!userIsSysAdmin && !userIsTravelCoordinator) {
      return null;
    }
    return (
      <IconButton className="travel-study-folder-edit-button" onClick={openEditLinkModal} disabled={false} size="small">
        <EditIcon className="travel-study-folder-edit-icon" fontSize="small" />
      </IconButton>
    );
  };

  const resolveLinkName = () => {
    const { displayName } = studyDetails?.travelStudyFolder;
    return displayName || t('openFolder', { ns: NSPS_STUDY });
  };

  if ((!userIsSysAdmin && !userIsTravelCoordinator) || !isStudyTypeCTMS) return null;

  return (
    <div className="col-4">
      <div className="form-group">
        <label htmlFor="travelStudyFolder">{t('travelStudyFolder', { ns: NSPS_STUDY })}</label>
        <div className="travel-study-folder-group">
          <FolderOpenOutlinedIcon className="travel-study-folder-icon" fontSize="large" />
          {studyDetails?.travelStudyFolder?.link ? (
            <Tooltip title={studyDetails.travelStudyFolder.link} placement="top">
              <Link className="travel-study-folder-link" href={studyDetails.travelStudyFolder.link} underline="hover">
                {resolveLinkName()}
              </Link>
            </Tooltip>
          ) : (
            <span>{t('openFolder', { ns: NSPS_STUDY })}</span>
          )}
          {renderEditIconButton()}
        </div>
      </div>
    </div>
  );
}
